export default "__VITE_ASSET__BwDa6fGm__"